// NPM Imports
import React from "react";
import { connect } from "react-redux";

// Components Imports
import NavBar from "./NavBar";

// Internals Imports
import { GlobalUtils } from "../../utils";

// Destructuring
const { readDataFromLocalStorage } = GlobalUtils;

const NavBarWrapper = props => {
  const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
  let navBar = null;
  /**
   * Making below flag false will again start showing Navbar in editor pages
   * but will cause CSS issues
   * To fully revert the change also add 'margin-left: 75px;' to .template-page & .quotations-page
   */
  const hideNavbarOnEditorPages = true;
  if (CURRENT_USER) {
    const {
      location: { pathname },
      show,
    } = props;
    let isSharedDocumentPage = false;
    let isPermaSharedDocument = false;
    let isMasterDocument = false;
    if (pathname.includes("/shared/documents/")) {
      isSharedDocumentPage = true;
    } else if (pathname.includes("/perma/DOC") || pathname.includes("/m/")) {
      isPermaSharedDocument = true;
    } else if (pathname.includes("/f/")) {
      isMasterDocument = true;
    }
    if (isMasterDocument) {
      navBar = null;
    } else if (isPermaSharedDocument) {
      navBar = null;
    } else if (isSharedDocumentPage) {
      const { sharedUser } = props;
      if (
        sharedUser &&
        sharedUser.id === CURRENT_USER.id &&
        sharedUser.user_email === CURRENT_USER.user_email
      ) {
        // navBar = <NavBar {...props} />;
        navBar = null;
      }
    } else if (show) {
      navBar = <NavBar {...props} />;
    } else if (
      hideNavbarOnEditorPages &&
      /**
       * !pathname.includes("/assets/") - this condition prevents hiding the navbar on assets page
       * if a user has created a folder called template or documents
       */
      !pathname.includes("/assets/") &&
      (pathname.includes("/template/") ||
        pathname.includes("/documents/") ||
        pathname.includes("/preview/templates/") ||
        pathname.includes("/signing-documents") ||
        pathname.includes("/transactionplan"))
    ) {
      // hide navbar if user is on docs or template page
      navBar = null;
    } else {
      navBar = <NavBar {...props} />;
    }
  }

  return navBar;
};

const mapStateToProps = state => {
  const { sharedUser } = state.SharedDocument;
  const { show } = state.NavbarWrapperStore;
  return { sharedUser, show };
};

export default connect(mapStateToProps, null)(NavBarWrapper);
